export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/Worker.2ae4d325.worker.js");
}
